import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import React from 'react';

const IconLink = (props: {
    disabled: boolean;
    onClick: Function;
    SvgIcon?: any;
    testId?: string;
    children: React.ReactNode;
}) => {
    const { disabled, onClick, SvgIcon, testId, children } = props;

    return (
        <Button
            variant="text"
            component={Link}
            href="#"
            disabled={disabled}
            underline={disabled ? 'none' : 'hover'}
            style={{
                display: 'flex',
                alignItems: 'center',
                fontWeight: '500',
                fontSize: '13px',
                lineHeight: '20px',
                marginLeft: SvgIcon ? '20px' : '0px',
                color: disabled ? 'textSecondary' : 'primary',
                backgroundColor: 'transparent',
            }}
            onClick={() => onClick()}
            data-testid={testId}
        >
            {SvgIcon ? <SvgIcon color={disabled ? 'textSecondary' : 'primary'} /> : null}
            <div
                style={{ marginLeft: '8px' }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = 'underline';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.textDecoration = 'none';
                }}
            >
                {children}
            </div>
        </Button>
    );
};

export default IconLink;
